import React, { useState } from "react";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";
import Header from "../components/Header";
export default function ShopPage() {
    const [showFilters, setShowFilters] = useState(false);
    const products = [
        { name: "Men T-Shirt", price: 499 },
        { name: "Women Dress", price: 899 },
        { name: "Sports Shoes", price: 1299 },
        { name: "Jacket", price: 1599 },
        { name: "Casual Shirt", price: 699 },
        { name: "Leather Belt", price: 299 },
        { name: "Sneakers", price: 1199 },
        { name: "Watch", price: 2499 },
    ];
    return (
        <div>
            <Header />
            <div className="shop-page">
                <div className="filter-sidebar">
                    <h3>Filters</h3>
                    <div className="filter-group">
                        <h4>Category</h4>
                        <label><input type="checkbox" /> Clothing</label>
                        <label><input type="checkbox" /> Shoes</label>
                        <label><input type="checkbox" /> Accessories</label>
                    </div>
                    <div className="filter-group">
                        <h4>Price</h4>
                        <label><input type="radio" name="price" /> Under ₹500</label>
                        <label><input type="radio" name="price" /> ₹500 - ₹1000</label>
                        <label><input type="radio" name="price" /> Above ₹1000</label>
                    </div>
                </div>
                <div className="products-area">
                    <div className="shop-search">
                        <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>Filters</button>
                    </div>
                    {showFilters && (
                        <div className="filter-sidebar-mobile">
                            <div className="filter-header">
                                <h3>Filters</h3>
                                <button className="close-btn" onClick={() => setShowFilters(false)}>✖</button>
                            </div>
                            <div className="filter-group">
                                <h4>Category</h4>
                                <label><input type="checkbox" /> Clothing</label>
                                <label><input type="checkbox" /> Shoes</label>
                                <label><input type="checkbox" /> Accessories</label>
                            </div>
                            <div className="filter-group">
                                <h4>Price</h4>
                                <label><input type="radio" name="price-mobile" /> Under ₹500</label>
                                <label><input type="radio" name="price-mobile" /> ₹500 - ₹1000</label>
                                <label><input type="radio" name="price-mobile" /> Above ₹1000</label>
                            </div>
                        </div>
                    )}
                    <div className="products-container">
                        {products.map((p, i) => (
                            <ProductCard key={i} {...p} />
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}